import './App.css';
import './styles/style.css'; // Importing CSS file
import React, { useState, useEffect } from 'react';
import FishTank from './components/FishTank';


const YtPart = () => {
  const [commenters, setCommenters] = useState([]);
  const [latestVideoId, setLatestVideoId] = useState(null); // State to hold the latest video ID
  const [panel, setPanel] = useState("");
  const [theme, setTheme] = useState("Old School");
  const [canvasbackground, setBackground] = useState(process.env.PUBLIC_URL + "/massivewater2.png")


  useEffect(() => {
    setPanel("tank")
  }, []);

  const handlePanelBtnClick = (panel) => {
    setPanel(panel)
  };


  useEffect(() => {
    const fetchChannelInfo = async () => {
      try {
        const channelId = "UCMWvOmwaFNB-uhBJUTZwvCA";  // Replace with the actual channel ID
        const functionUrl = `https://technozenapi.azurewebsites.net/api/getChannelInfo?channelId=${channelId}`;
  
        const response = await fetch(functionUrl);
        const data = await response.json();
  
        if (response.ok) {
          setLatestVideoId(data.latestVideoId);
          setCommenters(data.commenters);
        } else {
          console.error("Error:", data);
        }
      } catch (error) {
        console.error("Error fetching data from function:", error);
      }
    };
  
    fetchChannelInfo();
  }, []);
  

  const getIconSource = () => {
    switch (panel) {
      case 'tank':
        return process.env.PUBLIC_URL + '/dsbuttonblue.png'; // Replace with your tank icon path
      case 'latestvideo':
        return process.env.PUBLIC_URL + '/dsbuttonred.png'; // Replace with your latest video icon path
      case 'gallary':
        return process.env.PUBLIC_URL + '/dsbuttongreen.png'; // Replace with your gallery icon path
      case 'about':
        return process.env.PUBLIC_URL + '/dsbuttonyellow.png'; // Replace with your about icon path
      default:
        return process.env.PUBLIC_URL + '/dsbuttonblue.png'; // Default icon path
    }
  };

  const handleBackgroundChange = () => {
    setBackground(canvasbackground === process.env.PUBLIC_URL + '/massivewater2.png' 
      ? process.env.PUBLIC_URL +  '/realbg.png' 
      : process.env.PUBLIC_URL +  '/massivewater2.png');
  };

  const handleThemeChange = () => {
    setTheme(theme === 'Frutiger Aero' ? 'Old School' : 'Frutiger Aero');
  };

  return (
    <div id='app'>
      <div id='Header'>
        <title>TECHNOZEN!!!!</title>
        <img id='logo' src={process.env.PUBLIC_URL + '/technozenlogo.png'} alt="Header" />
        <img id='headerimg' src={process.env.PUBLIC_URL + '/beachtemp.png'} alt="Header" />
      </div>
      <div className='TankHolder'>
        
        <div id='content'>
          {/* TANK */}
          <div className={`panel canvaspanel ${panel === 'tank' ? 'active' : ''}`}>
          <FishTank commenters={commenters} theme={theme} canvasbackground={canvasbackground} />
          <p id='testText'>LATEST COMMENTERS</p>
          <div id='themeBtnContainer'>
            <span id='themeText'>Theme: {theme}</span>
            <button 
              onClick={() => { handleBackgroundChange(); handleThemeChange(); }} 
              id="switchThemeBtn1"
            >
              SWITCH THEME
            </button>
          </div>
        </div>

          {/* GALLARY */}
          <div className={`panel ${panel === 'gallary' ? 'active' : ''}`}>
          <img id='galleryborder1' src={process.env.PUBLIC_URL + '/flower1.png'} alt="fuckyoueslint"/>
          <img id='galleryborder2' src={process.env.PUBLIC_URL + '/flower2.png'} alt="fuckyoueslint"/>
            <div className='titletext' id='canvastitlecontainer'>
              <p id='canvastitletext'>Art by Ocarin!</p>
            </div>
            <img id='latestvideo' src={process.env.PUBLIC_URL + '/gallarythumb.png'} alt="Header" />
            <div>
                    <a 
                      href={`https://xocarin.github.io/`} 
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      <button className="sideBtn video-link-button">Go to Gallery</button>
                    </a>
                  </div>
            </div>

          {/* ABOUT */}
          <div className={`panel aboutpanel ${panel === 'about' ? 'active' : ''}`}>
          <img id='galleryborder1' src={process.env.PUBLIC_URL + '/ocean1.png'} alt="fuckyoueslint"/>
          <img id='galleryborder2' src={process.env.PUBLIC_URL + '/ocean2.png'} alt="fuckyoueslint"/>
            <img id='pfpImg' src={process.env.PUBLIC_URL + '/pfp.png'} alt="Description" />
            <p className='aboutpaneltext'>Hello, and welcome to Techn0zen.com!</p>
            <p className='aboutpaneltext'>This is a companion website for the <a href='https://www.youtube.com/@Ocarin_'>Techn0zen Youtube Channel</a> created by me, <a href="https://x.com/cs_Ocarin">@Ocarin</a></p>
            <p className='aboutpaneltext'>My hope is that i can continue to update this site with fun interactive ways to engage with the channel.</p>
            <p className='aboutpaneltext'>Please enjoy, and thank you for watching!</p>

          </div>

          {/* LATEST VIDEO */}
          <div className={`panel ${panel === 'latestvideo' ? 'active' : ''}`}>
            <img id='galleryborder1' src={process.env.PUBLIC_URL + '/forest1.png'} alt="fuckyoueslint"/>
            <img id='galleryborder2' src={process.env.PUBLIC_URL + '/forest2.png'} alt="fuckyoueslint"/>
            {latestVideoId ? (
              <>
                <div className='titletext' id='canvastitlecontainer'>
                  <p id='canvastitletext'>Latest Techn0zen video:</p>
                </div>
                <iframe
                  id='latestvideo' 
                  className='maincontentofpanel'
                  src={`https://www.youtube.com/embed/${latestVideoId}`} 
                  title="Latest Video" 
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                  allowFullScreen
                ></iframe>
                <div>
                  <a 
                    href={`https://www.youtube.com/watch?v=${latestVideoId}`} 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    <button className="sideBtn video-link-button">Watch on YouTube</button>
                  </a>
                </div>
              </>
            ) : (
              <p>Loading latest video...</p>
            )}
          </div>
        </div>
      </div>
      <div id='Footer'>
          <div id='navDiv'>
            <button
              className={`sideBtn ${panel === 'tank' ? 'active' : ''}`}
              onClick={() => handlePanelBtnClick("tank")}
            >
              <span className="indicator"> </span> The Tank
            </button>
            <button
              className={`sideBtn ${panel === 'latestvideo' ? 'active' : ''}`}
              onClick={() => handlePanelBtnClick("latestvideo")}
            >
              <span className="indicator"> </span> Latest Video
            </button>
            
            <img id='iconImg' src={getIconSource()}  alt="fuckyoueslint" />
            
            <button
              className={`sideBtn ${panel === 'gallary' ? 'active' : ''}`}
              onClick={() => handlePanelBtnClick("gallary")}
            >
              <span className="indicator"> </span> Gallery
            </button>
            <button
              className={`sideBtn ${panel === 'about' ? 'active' : ''}`}
              onClick={() => handlePanelBtnClick("about")}
            >
              <span className="indicator"> </span> About
            </button>
          </div>
      </div>
    </div>
  );
};
//639455600050-drssofemq3r3nfdhkndop316afmd1pqa.apps.googleusercontent.com
export default YtPart;

